import DataGrid2 from '../..';

export function customSave(this: DataGrid2, { searchText, columns, pageIndex, pageSize }) {
	localStorage.setItem(
		getStorageKey.call(this),
		JSON.stringify({ searchText, columns, pageIndex, pageSize })
	);
}

export function customLoad(this: DataGrid2) {
	const state = localStorage.getItem(getStorageKey.call(this));

	if (state) {
		try {
			return JSON.parse(state);
		} catch {
			return {};
		}
	}

	return {};
}

function getStorageKey(this: DataGrid2) {
	return `Runtime_${this.__form.projectName}_${this.__form.name}_${this.name}`;
}
